import { ENotificationType } from 'models/notifications'

export const getNotificationTypeName = (type: ENotificationType) => {
  switch (type) {
    case ENotificationType.COLLECTION:
      return 'Подборка'
    case ENotificationType.PRODUCT:
      return 'Товар'
    case ENotificationType.FAVORITES:
      return 'Избранное'
    case ENotificationType.SUBCATEGORY:
      return 'Подкатегория'
    default:
      return ''
  }
}
